import * as productApi from '../../api/product-api';
import {
    IOrderDetails,
    IProductDetail,
    IReceiverPart,
} from '../../models/product-detail';
import { IResult } from '../../models/result-models';
import {
    apiCallError,
    beginApiCall,
    endApiCall,
} from '../api/api-status-action';

import { Dispatch } from 'redux';
import externalSite from '../../global-functions';
import { clearSavedCart } from '../cart/cart-actions';
import { IUpdateOptionData } from '../../models/order';
import { cartItemType } from '../../models/cart-item-type-constants';

export const CLEAR_PRODUCT_DETAILS_SUCCESS = 'CLEAR_PRODUCT_DETAILS_SUCCESS';
export const LOAD_PRODUCT_DETAILS_SUCCESS = 'LOAD_PRODUCT_DETAILS_SUCCESS';
export const LOAD_RETURNING_PRODUCT_DETAILS_SUCCESS =
    'LOAD_RETURNING_PRODUCT_DETAILS_SUCCESS';
//Actions
export const clearProductDetailsSuccess = () => ({
    type: CLEAR_PRODUCT_DETAILS_SUCCESS,
});

export const loadProductDetailsSuccess = (result: IResult<IProductDetail>) => ({
    type: LOAD_PRODUCT_DETAILS_SUCCESS,
    result,
});
export const loadReturningProductDetailsSuccess = (
    result: IResult<IProductDetail>
) => ({
    type: LOAD_RETURNING_PRODUCT_DETAILS_SUCCESS,
    result,
});

//thunks
export const clearProductDetails = () => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch(beginApiCall('CLEAR_PRODUCT_DETAILS'));
            dispatch(clearProductDetailsSuccess());
        } catch (error) {
            dispatch(apiCallError(error, 'CLEAR_PRODUCT_DETAILS'));
            throw error;
        }
    };
};

export const loadProductDetails = (guid: string, cId: string) => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch(beginApiCall());
            const result = await productApi.getProductDetails(guid, cId);
            if (result) {
                dispatch(loadProductDetailsSuccess(result));
            }
            return result.ok;
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};

export const addToCart = (order: IOrderDetails) => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch(beginApiCall('ADD_PRODUCT_TO_CART'));
            const result = await productApi.addToCart(order);
            if (result.ok) {
                externalSite.updateCart();
                dispatch(endApiCall('ADD_PRODUCT_TO_CART'));
                dispatch(clearSavedCart());
            } else {
                dispatch(apiCallError(result.errors, 'ADD_PRODUCT_TO_CART'));
            }
            return result.ok;
        } catch (error) {
            dispatch(apiCallError(error, 'ADD_PRODUCT_TO_CART'));
            throw error;
        }
    };
};

export const addReceiversToCart = (receivers: IReceiverPart[]) => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch(beginApiCall('ADD_RECEIVER_TO_CART'));
            const result = await productApi.addReceiversToCart(receivers);
            if (result.ok) {
                externalSite.updateCart();
                dispatch(endApiCall('ADD_RECEIVER_TO_CART'));
                dispatch(clearSavedCart());
            } else {
                dispatch(apiCallError(result.errors, 'ADD_RECEIVER_TO_CART'));
            }
            return result.ok;
        } catch (error) {
            dispatch(apiCallError(error, 'ADD_RECEIVER_TO_CART'));
            throw error;
        }
    };
};

export const loadReturningProductDetails = (
    guid: string,
    //options: IUpdateOptionData
    orderNumber: string
) => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch(beginApiCall());
            const result = await productApi.getReturningProductDetails(
                guid,
                orderNumber
            );
            if (result) {
                /*
                result.data!.existing = {
                    ...result.data!.existing,
                    agreement_Type:
                        options.patient && options.patient.agreementType
                            ? options.patient.agreementType
                            : ,
                    agreement_State:
                        options.patient && options.patient.agreementState
                            ? options.patient.agreementState
                            : '',
                    agreement_Reference:
                        options.patient && options.patient.agreementReference
                            ? options.patient.agreementReference
                            : '',
                    agreement_Info:
                        options.patient && options.patient.agreementInfo
                            ? options.patient.agreementInfo
                            : '',
                    description: options.cartItem.description,
                    imageUrl: options.cartItem.imageUrl,
                    isPatient: options.patient ? true : false,
                    quantity: options.cartItem.quantity,
                    rightOptions: [], //need to receive
                    leftOptions: [], //need to receive
                    itemID: options.cartItem.id,
                    options: options.lineItem.option,
                    color: options.cartItem.color,
                    url: options.cartItem.productUrl,
                    blockQuantityUpdate: options.cartItem.blockQuantityUpdate
                };
                */
                console.log(result);
                dispatch(loadReturningProductDetailsSuccess(result));
            }
            return result.ok;
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};
